var map = {
	"./assets/fonts/iconfont/iconfont.json": [
		27451,
		27451
	],
	"./components/annual-report/2025/images/clock.json": [
		13912,
		13912
	],
	"./components/annual-report/components/Indicator/spinner-loading.json": [
		18774,
		18774
	],
	"./components/annual-report/images/clock.json": [
		33196,
		33196
	],
	"./components/common/Loading/latino/loading-v2.json": [
		83195,
		83195
	],
	"./components/common/Loading/loading-v2.json": [
		80978,
		80978
	],
	"./components/common/ProductCard/sku-product/mock.json": [
		29927,
		29927
	],
	"./components/order/OrderSuccessGroupB/order_confirm.json": [
		98401,
		98401
	],
	"./components/pdp/ProductQA/QAChatDialog/entering_ai.json": [
		79310,
		79310
	],
	"./components/vendors/raffle/LuckyWheelRaffleV2/lucky-wheel-bg.json": [
		65438,
		65438
	],
	"./latino-locales/en/addon.json": [
		80630,
		80630
	],
	"./latino-locales/en/annualReport.json": [
		66921,
		66921
	],
	"./latino-locales/en/campaigns.json": [
		41820,
		41820
	],
	"./latino-locales/en/checkout.json": [
		30189,
		37433
	],
	"./latino-locales/en/combine.json": [
		80196,
		80196
	],
	"./latino-locales/en/common.json": [
		76696,
		76696
	],
	"./latino-locales/en/couponLanding.json": [
		80543,
		80543
	],
	"./latino-locales/en/freebies.json": [
		82501,
		82501
	],
	"./latino-locales/en/ftu.json": [
		3282,
		3282
	],
	"./latino-locales/en/gift-card.json": [
		53175,
		53175
	],
	"./latino-locales/en/goldRewards.json": [
		55554,
		55554
	],
	"./latino-locales/en/groupOrder.json": [
		58478,
		58478
	],
	"./latino-locales/en/guideline.json": [
		30421,
		30421
	],
	"./latino-locales/en/helpCenter.json": [
		80589,
		80589
	],
	"./latino-locales/en/home.json": [
		17113,
		17113
	],
	"./latino-locales/en/mkplRaffle.json": [
		23383,
		23383
	],
	"./latino-locales/en/mylist.json": [
		81574,
		81574
	],
	"./latino-locales/en/onboarding.json": [
		94355,
		94355
	],
	"./latino-locales/en/order.json": [
		25416,
		25416
	],
	"./latino-locales/en/orderList.json": [
		84753,
		84753
	],
	"./latino-locales/en/orderShare.json": [
		69177,
		69177
	],
	"./latino-locales/en/orderSuccess.json": [
		82868,
		82868
	],
	"./latino-locales/en/pdp.json": [
		24481,
		24481
	],
	"./latino-locales/en/points.json": [
		67796,
		67796
	],
	"./latino-locales/en/product-card.json": [
		6489,
		6489
	],
	"./latino-locales/en/promotion.json": [
		11705,
		11705
	],
	"./latino-locales/en/raffle.json": [
		4360,
		4360
	],
	"./latino-locales/en/referral.json": [
		5080,
		5080
	],
	"./latino-locales/en/refund.json": [
		56825,
		56825
	],
	"./latino-locales/en/restaurant.json": [
		50324,
		50324
	],
	"./latino-locales/en/review.json": [
		1700,
		1700
	],
	"./latino-locales/en/seo.json": [
		61268,
		61268
	],
	"./latino-locales/en/student.json": [
		69216,
		69216
	],
	"./latino-locales/en/subscribe.json": [
		14996,
		14996
	],
	"./latino-locales/en/topic.json": [
		17120,
		17120
	],
	"./latino-locales/en/vendor.json": [
		74684,
		74684
	],
	"./latino-locales/es/addon.json": [
		84050,
		84050
	],
	"./latino-locales/es/annualReport.json": [
		60768,
		60768
	],
	"./latino-locales/es/campaigns.json": [
		26114,
		26114
	],
	"./latino-locales/es/checkout.json": [
		91337,
		19524
	],
	"./latino-locales/es/combine.json": [
		48286,
		48286
	],
	"./latino-locales/es/common.json": [
		55671,
		55671
	],
	"./latino-locales/es/couponLanding.json": [
		97706,
		97706
	],
	"./latino-locales/es/freebies.json": [
		66819,
		66819
	],
	"./latino-locales/es/ftu.json": [
		30655,
		30655
	],
	"./latino-locales/es/gift-card.json": [
		37626,
		37626
	],
	"./latino-locales/es/goldRewards.json": [
		25196,
		25196
	],
	"./latino-locales/es/groupOrder.json": [
		83885,
		83885
	],
	"./latino-locales/es/guideline.json": [
		49787,
		49787
	],
	"./latino-locales/es/helpCenter.json": [
		40509,
		40509
	],
	"./latino-locales/es/home.json": [
		38982,
		38982
	],
	"./latino-locales/es/mkplRaffle.json": [
		68243,
		68243
	],
	"./latino-locales/es/mylist.json": [
		30578,
		30578
	],
	"./latino-locales/es/onboarding.json": [
		75855,
		75855
	],
	"./latino-locales/es/order.json": [
		91194,
		91194
	],
	"./latino-locales/es/orderList.json": [
		87388,
		87388
	],
	"./latino-locales/es/orderShare.json": [
		16600,
		28906
	],
	"./latino-locales/es/orderSuccess.json": [
		48868,
		48868
	],
	"./latino-locales/es/pdp.json": [
		43939,
		43939
	],
	"./latino-locales/es/points.json": [
		5843,
		5843
	],
	"./latino-locales/es/product-card.json": [
		3399,
		3399
	],
	"./latino-locales/es/promotion.json": [
		99912,
		99912
	],
	"./latino-locales/es/raffle.json": [
		29244,
		29244
	],
	"./latino-locales/es/referral.json": [
		70765,
		70765
	],
	"./latino-locales/es/refund.json": [
		24423,
		24423
	],
	"./latino-locales/es/restaurant.json": [
		85176,
		85176
	],
	"./latino-locales/es/review.json": [
		88704,
		88704
	],
	"./latino-locales/es/seo.json": [
		12214,
		12214
	],
	"./latino-locales/es/student.json": [
		1934,
		1934
	],
	"./latino-locales/es/subscribe.json": [
		33686,
		33686
	],
	"./latino-locales/es/topic.json": [
		52389,
		52389
	],
	"./latino-locales/es/vendor.json": [
		71063,
		71063
	],
	"./latino-locales/pt/addon.json": [
		92281,
		92281
	],
	"./latino-locales/pt/campaigns.json": [
		47354,
		47354
	],
	"./latino-locales/pt/checkout.json": [
		90258,
		90258
	],
	"./latino-locales/pt/combine.json": [
		34086,
		34086
	],
	"./latino-locales/pt/common.json": [
		42603,
		42603
	],
	"./latino-locales/pt/couponLanding.json": [
		29044,
		29044
	],
	"./latino-locales/pt/freebies.json": [
		66007,
		66007
	],
	"./latino-locales/pt/ftu.json": [
		5208,
		5208
	],
	"./latino-locales/pt/gift-card.json": [
		21723,
		21723
	],
	"./latino-locales/pt/goldRewards.json": [
		7671,
		7671
	],
	"./latino-locales/pt/groupOrder.json": [
		10329,
		10329
	],
	"./latino-locales/pt/guideline.json": [
		38673,
		38673
	],
	"./latino-locales/pt/helpCenter.json": [
		53937,
		53937
	],
	"./latino-locales/pt/home.json": [
		12438,
		12438
	],
	"./latino-locales/pt/mkplRaffle.json": [
		13438,
		13438
	],
	"./latino-locales/pt/mylist.json": [
		74790,
		74790
	],
	"./latino-locales/pt/onboarding.json": [
		15736,
		15736
	],
	"./latino-locales/pt/order.json": [
		79180,
		79180
	],
	"./latino-locales/pt/orderList.json": [
		35145,
		35145
	],
	"./latino-locales/pt/orderShare.json": [
		68892,
		68892
	],
	"./latino-locales/pt/orderSuccess.json": [
		31346,
		31346
	],
	"./latino-locales/pt/pdp.json": [
		6167,
		6167
	],
	"./latino-locales/pt/points.json": [
		37758,
		37758
	],
	"./latino-locales/pt/product-card.json": [
		85197,
		85197
	],
	"./latino-locales/pt/promotion.json": [
		51491,
		51491
	],
	"./latino-locales/pt/raffle.json": [
		23934,
		23934
	],
	"./latino-locales/pt/referral.json": [
		63405,
		63405
	],
	"./latino-locales/pt/refund.json": [
		7658,
		7658
	],
	"./latino-locales/pt/restaurant.json": [
		30138,
		30138
	],
	"./latino-locales/pt/review.json": [
		53513,
		61827
	],
	"./latino-locales/pt/seo.json": [
		51262,
		51262
	],
	"./latino-locales/pt/student.json": [
		95204,
		95204
	],
	"./latino-locales/pt/subscribe.json": [
		31190,
		31190
	],
	"./latino-locales/pt/topic.json": [
		1510,
		1510
	],
	"./latino-locales/pt/vendor.json": [
		13150,
		13150
	],
	"./locales/en/addon.json": [
		4899,
		4899
	],
	"./locales/en/annualReport.json": [
		56512,
		56512
	],
	"./locales/en/campaigns.json": [
		79735,
		79735
	],
	"./locales/en/checkout.json": [
		84798,
		84798
	],
	"./locales/en/combine.json": [
		34112,
		34112
	],
	"./locales/en/common.json": [
		83147,
		83147
	],
	"./locales/en/couponLanding.json": [
		34322,
		92226
	],
	"./locales/en/freebies.json": [
		45712,
		45712
	],
	"./locales/en/ftu.json": [
		75257,
		75257
	],
	"./locales/en/gift-card.json": [
		63114,
		63114
	],
	"./locales/en/goldRewards.json": [
		38622,
		38622
	],
	"./locales/en/groupOrder.json": [
		75909,
		75909
	],
	"./locales/en/helpCenter.json": [
		62330,
		62330
	],
	"./locales/en/home.json": [
		82361,
		82361
	],
	"./locales/en/mkplRaffle.json": [
		22213,
		2416
	],
	"./locales/en/mylist.json": [
		93706,
		93706
	],
	"./locales/en/onboarding.json": [
		77623,
		77623
	],
	"./locales/en/order.json": [
		32974,
		32974
	],
	"./locales/en/orderList.json": [
		13784,
		13784
	],
	"./locales/en/orderShare.json": [
		13406,
		13406
	],
	"./locales/en/orderSuccess.json": [
		64601,
		64601
	],
	"./locales/en/pdp.json": [
		16111,
		16111
	],
	"./locales/en/points.json": [
		69409,
		69409
	],
	"./locales/en/product-card.json": [
		18815,
		18815
	],
	"./locales/en/promotion.json": [
		81000,
		81000
	],
	"./locales/en/raffle.json": [
		5411,
		5411
	],
	"./locales/en/referral.json": [
		8461,
		8461
	],
	"./locales/en/refund.json": [
		53885,
		53885
	],
	"./locales/en/restaurant.json": [
		77215,
		78030
	],
	"./locales/en/review.json": [
		55802,
		55802
	],
	"./locales/en/seo.json": [
		30214,
		30214
	],
	"./locales/en/student.json": [
		51977,
		51977
	],
	"./locales/en/subscribe.json": [
		37632,
		37632
	],
	"./locales/en/topic.json": [
		7237,
		7237
	],
	"./locales/en/vendor.json": [
		87318,
		87318
	],
	"./locales/es/campaigns.json": [
		53718,
		53718
	],
	"./locales/es/checkout.json": [
		21309,
		21309
	],
	"./locales/es/common.json": [
		44501,
		44501
	],
	"./locales/ja/addon.json": [
		49121,
		49121
	],
	"./locales/ja/annualReport.json": [
		38230,
		38230
	],
	"./locales/ja/campaigns.json": [
		79408,
		79408
	],
	"./locales/ja/checkout.json": [
		3049,
		3049
	],
	"./locales/ja/combine.json": [
		29543,
		29543
	],
	"./locales/ja/common.json": [
		16865,
		16865
	],
	"./locales/ja/couponLanding.json": [
		17680,
		17680
	],
	"./locales/ja/freebies.json": [
		31794,
		31794
	],
	"./locales/ja/ftu.json": [
		62729,
		1019
	],
	"./locales/ja/gift-card.json": [
		84638,
		84638
	],
	"./locales/ja/goldRewards.json": [
		66453,
		66453
	],
	"./locales/ja/groupOrder.json": [
		68488,
		68488
	],
	"./locales/ja/helpCenter.json": [
		58560,
		58560
	],
	"./locales/ja/home.json": [
		29353,
		29353
	],
	"./locales/ja/mkplRaffle.json": [
		58993,
		50587
	],
	"./locales/ja/mylist.json": [
		65512,
		65512
	],
	"./locales/ja/onboarding.json": [
		80444,
		80444
	],
	"./locales/ja/order.json": [
		74436,
		74436
	],
	"./locales/ja/orderList.json": [
		97785,
		97785
	],
	"./locales/ja/orderShare.json": [
		68075,
		68075
	],
	"./locales/ja/orderSuccess.json": [
		95498,
		95498
	],
	"./locales/ja/pdp.json": [
		71337,
		71337
	],
	"./locales/ja/points.json": [
		21303,
		21303
	],
	"./locales/ja/product-card.json": [
		17516,
		17516
	],
	"./locales/ja/promotion.json": [
		5718,
		5718
	],
	"./locales/ja/raffle.json": [
		61923,
		61923
	],
	"./locales/ja/referral.json": [
		30611,
		30611
	],
	"./locales/ja/refund.json": [
		20236,
		20236
	],
	"./locales/ja/restaurant.json": [
		95555,
		53602
	],
	"./locales/ja/review.json": [
		45096,
		45096
	],
	"./locales/ja/seo.json": [
		93041,
		93041
	],
	"./locales/ja/student.json": [
		84277,
		84277
	],
	"./locales/ja/subscribe.json": [
		32334,
		32334
	],
	"./locales/ja/topic.json": [
		11529,
		11529
	],
	"./locales/ja/vendor.json": [
		30504,
		30504
	],
	"./locales/ko/addon.json": [
		88888,
		88888
	],
	"./locales/ko/annualReport.json": [
		98753,
		98753
	],
	"./locales/ko/campaigns.json": [
		92991,
		92991
	],
	"./locales/ko/checkout.json": [
		91440,
		91440
	],
	"./locales/ko/combine.json": [
		66822,
		66822
	],
	"./locales/ko/common.json": [
		7629,
		7629
	],
	"./locales/ko/couponLanding.json": [
		2087,
		2087
	],
	"./locales/ko/freebies.json": [
		20625,
		20625
	],
	"./locales/ko/ftu.json": [
		9481,
		9481
	],
	"./locales/ko/gift-card.json": [
		14239,
		14239
	],
	"./locales/ko/goldRewards.json": [
		67836,
		67836
	],
	"./locales/ko/groupOrder.json": [
		91775,
		79085
	],
	"./locales/ko/helpCenter.json": [
		13539,
		13539
	],
	"./locales/ko/home.json": [
		71225,
		71225
	],
	"./locales/ko/mkplRaffle.json": [
		26657,
		26657
	],
	"./locales/ko/mylist.json": [
		56413,
		56413
	],
	"./locales/ko/onboarding.json": [
		63949,
		63949
	],
	"./locales/ko/order.json": [
		78812,
		78812
	],
	"./locales/ko/orderList.json": [
		61434,
		61434
	],
	"./locales/ko/orderShare.json": [
		16169,
		16169
	],
	"./locales/ko/orderSuccess.json": [
		72837,
		72837
	],
	"./locales/ko/pdp.json": [
		85041,
		85041
	],
	"./locales/ko/points.json": [
		25822,
		25822
	],
	"./locales/ko/product-card.json": [
		46103,
		46103
	],
	"./locales/ko/promotion.json": [
		34042,
		34042
	],
	"./locales/ko/raffle.json": [
		62937,
		62937
	],
	"./locales/ko/referral.json": [
		75997,
		75997
	],
	"./locales/ko/refund.json": [
		13434,
		13434
	],
	"./locales/ko/restaurant.json": [
		17665,
		17665
	],
	"./locales/ko/review.json": [
		20245,
		20245
	],
	"./locales/ko/seo.json": [
		45171,
		45171
	],
	"./locales/ko/student.json": [
		21063,
		21063
	],
	"./locales/ko/subscribe.json": [
		29505,
		29505
	],
	"./locales/ko/topic.json": [
		68616,
		68616
	],
	"./locales/ko/vendor.json": [
		18520,
		18520
	],
	"./locales/pt/campaigns.json": [
		82078,
		82078
	],
	"./locales/pt/checkout.json": [
		71726,
		71726
	],
	"./locales/pt/common.json": [
		25137,
		25137
	],
	"./locales/pt/student.json": [
		43365,
		43365
	],
	"./locales/th/addon.json": [
		66064,
		66064
	],
	"./locales/th/annualReport.json": [
		95383,
		95383
	],
	"./locales/th/campaigns.json": [
		11455,
		11455
	],
	"./locales/th/checkout.json": [
		85919,
		85919
	],
	"./locales/th/combine.json": [
		40517,
		40517
	],
	"./locales/th/common.json": [
		36109,
		36109
	],
	"./locales/th/couponLanding.json": [
		59216,
		59216
	],
	"./locales/th/freebies.json": [
		28664,
		28664
	],
	"./locales/th/ftu.json": [
		76981,
		76981
	],
	"./locales/th/gift-card.json": [
		1579,
		1579
	],
	"./locales/th/goldRewards.json": [
		1783,
		1783
	],
	"./locales/th/groupOrder.json": [
		82942,
		82942
	],
	"./locales/th/helpCenter.json": [
		59618,
		59618
	],
	"./locales/th/home.json": [
		70537,
		70537
	],
	"./locales/th/mkplRaffle.json": [
		92865,
		12211
	],
	"./locales/th/mylist.json": [
		98416,
		98416
	],
	"./locales/th/onboarding.json": [
		76342,
		76342
	],
	"./locales/th/order.json": [
		34575,
		34575
	],
	"./locales/th/orderList.json": [
		83535,
		83535
	],
	"./locales/th/orderShare.json": [
		16665,
		16665
	],
	"./locales/th/orderSuccess.json": [
		32420,
		32420
	],
	"./locales/th/pdp.json": [
		74353,
		74353
	],
	"./locales/th/points.json": [
		58652,
		58652
	],
	"./locales/th/product-card.json": [
		5855,
		5855
	],
	"./locales/th/promotion.json": [
		33290,
		33290
	],
	"./locales/th/raffle.json": [
		57005,
		57005
	],
	"./locales/th/referral.json": [
		99811,
		99811
	],
	"./locales/th/refund.json": [
		58029,
		58029
	],
	"./locales/th/restaurant.json": [
		84325,
		91337
	],
	"./locales/th/review.json": [
		88302,
		88302
	],
	"./locales/th/seo.json": [
		84553,
		84553
	],
	"./locales/th/student.json": [
		63332,
		63332
	],
	"./locales/th/subscribe.json": [
		20130,
		20130
	],
	"./locales/th/topic.json": [
		77642,
		77642
	],
	"./locales/th/vendor.json": [
		72984,
		72984
	],
	"./locales/vi/addon.json": [
		83224,
		83224
	],
	"./locales/vi/annualReport.json": [
		6658,
		6658
	],
	"./locales/vi/campaigns.json": [
		82267,
		82267
	],
	"./locales/vi/checkout.json": [
		45933,
		45933
	],
	"./locales/vi/combine.json": [
		94957,
		94957
	],
	"./locales/vi/common.json": [
		35972,
		35972
	],
	"./locales/vi/couponLanding.json": [
		70110,
		70110
	],
	"./locales/vi/freebies.json": [
		57887,
		57887
	],
	"./locales/vi/ftu.json": [
		72804,
		72804
	],
	"./locales/vi/gift-card.json": [
		29519,
		29519
	],
	"./locales/vi/goldRewards.json": [
		2452,
		2452
	],
	"./locales/vi/groupOrder.json": [
		98742,
		98742
	],
	"./locales/vi/helpCenter.json": [
		22333,
		22333
	],
	"./locales/vi/home.json": [
		49009,
		49009
	],
	"./locales/vi/mkplRaffle.json": [
		75870,
		75870
	],
	"./locales/vi/mylist.json": [
		83223,
		83223
	],
	"./locales/vi/onboarding.json": [
		60842,
		60842
	],
	"./locales/vi/order.json": [
		50244,
		50244
	],
	"./locales/vi/orderList.json": [
		43446,
		43446
	],
	"./locales/vi/orderShare.json": [
		18092,
		18092
	],
	"./locales/vi/orderSuccess.json": [
		95417,
		95417
	],
	"./locales/vi/pdp.json": [
		37127,
		37127
	],
	"./locales/vi/points.json": [
		18324,
		18324
	],
	"./locales/vi/product-card.json": [
		3750,
		3750
	],
	"./locales/vi/promotion.json": [
		87773,
		87773
	],
	"./locales/vi/raffle.json": [
		81469,
		81469
	],
	"./locales/vi/referral.json": [
		52492,
		52492
	],
	"./locales/vi/refund.json": [
		41743,
		41743
	],
	"./locales/vi/restaurant.json": [
		18749,
		18749
	],
	"./locales/vi/review.json": [
		71128,
		71128
	],
	"./locales/vi/seo.json": [
		94783,
		94783
	],
	"./locales/vi/student.json": [
		80071,
		80071
	],
	"./locales/vi/subscribe.json": [
		67990,
		67990
	],
	"./locales/vi/topic.json": [
		26126,
		26126
	],
	"./locales/vi/vendor.json": [
		94162,
		94162
	],
	"./locales/zh/addon.json": [
		56368,
		56368
	],
	"./locales/zh/annualReport.json": [
		98828,
		98828
	],
	"./locales/zh/campaigns.json": [
		70908,
		70908
	],
	"./locales/zh/checkout.json": [
		84270,
		84270
	],
	"./locales/zh/combine.json": [
		71933,
		71933
	],
	"./locales/zh/common.json": [
		60072,
		60072
	],
	"./locales/zh/couponLanding.json": [
		2483,
		2483
	],
	"./locales/zh/freebies.json": [
		82746,
		82746
	],
	"./locales/zh/ftu.json": [
		63458,
		63458
	],
	"./locales/zh/gift-card.json": [
		21307,
		21307
	],
	"./locales/zh/goldRewards.json": [
		30780,
		30780
	],
	"./locales/zh/groupOrder.json": [
		8310,
		8310
	],
	"./locales/zh/helpCenter.json": [
		75545,
		75545
	],
	"./locales/zh/home.json": [
		99770,
		99770
	],
	"./locales/zh/mkplRaffle.json": [
		30606,
		30606
	],
	"./locales/zh/mylist.json": [
		38652,
		38652
	],
	"./locales/zh/onboarding.json": [
		15412,
		15412
	],
	"./locales/zh/order.json": [
		52136,
		52136
	],
	"./locales/zh/orderList.json": [
		1564,
		1564
	],
	"./locales/zh/orderShare.json": [
		99937,
		99937
	],
	"./locales/zh/orderSuccess.json": [
		39615,
		39615
	],
	"./locales/zh/pdp.json": [
		62337,
		62337
	],
	"./locales/zh/points.json": [
		75877,
		75877
	],
	"./locales/zh/product-card.json": [
		37659,
		37659
	],
	"./locales/zh/promotion.json": [
		92911,
		92911
	],
	"./locales/zh/raffle.json": [
		3517,
		3517
	],
	"./locales/zh/referral.json": [
		39140,
		39140
	],
	"./locales/zh/refund.json": [
		7534,
		47067
	],
	"./locales/zh/restaurant.json": [
		47277,
		47277
	],
	"./locales/zh/review.json": [
		60603,
		60603
	],
	"./locales/zh/seo.json": [
		11103,
		11103
	],
	"./locales/zh/student.json": [
		58912,
		58912
	],
	"./locales/zh/subscribe.json": [
		36046,
		36046
	],
	"./locales/zh/topic.json": [
		68458,
		68458
	],
	"./locales/zh/vendor.json": [
		57137,
		57137
	],
	"./locales/zht/addon.json": [
		70328,
		70328
	],
	"./locales/zht/annualReport.json": [
		83015,
		83015
	],
	"./locales/zht/campaigns.json": [
		15141,
		15141
	],
	"./locales/zht/checkout.json": [
		90240,
		90240
	],
	"./locales/zht/combine.json": [
		65651,
		65651
	],
	"./locales/zht/common.json": [
		13331,
		13331
	],
	"./locales/zht/couponLanding.json": [
		7914,
		7914
	],
	"./locales/zht/freebies.json": [
		25359,
		25359
	],
	"./locales/zht/ftu.json": [
		53347,
		85135
	],
	"./locales/zht/gift-card.json": [
		14309,
		14309
	],
	"./locales/zht/goldRewards.json": [
		63107,
		63107
	],
	"./locales/zht/groupOrder.json": [
		63876,
		63876
	],
	"./locales/zht/helpCenter.json": [
		55987,
		55987
	],
	"./locales/zht/home.json": [
		16061,
		16061
	],
	"./locales/zht/mkplRaffle.json": [
		56564,
		56564
	],
	"./locales/zht/mylist.json": [
		75167,
		75167
	],
	"./locales/zht/onboarding.json": [
		68191,
		68191
	],
	"./locales/zht/order.json": [
		10121,
		10121
	],
	"./locales/zht/orderList.json": [
		95951,
		95951
	],
	"./locales/zht/orderShare.json": [
		60196,
		60196
	],
	"./locales/zht/orderSuccess.json": [
		11482,
		11482
	],
	"./locales/zht/pdp.json": [
		25423,
		25423
	],
	"./locales/zht/points.json": [
		59685,
		59685
	],
	"./locales/zht/product-card.json": [
		88069,
		88069
	],
	"./locales/zht/promotion.json": [
		14,
		14
	],
	"./locales/zht/raffle.json": [
		5427,
		5427
	],
	"./locales/zht/referral.json": [
		3638,
		3638
	],
	"./locales/zht/refund.json": [
		40600,
		40600
	],
	"./locales/zht/restaurant.json": [
		1643,
		1643
	],
	"./locales/zht/review.json": [
		22637,
		22637
	],
	"./locales/zht/seo.json": [
		40128,
		40128
	],
	"./locales/zht/student.json": [
		45325,
		15226
	],
	"./locales/zht/subscribe.json": [
		80104,
		80104
	],
	"./locales/zht/topic.json": [
		22374,
		22374
	],
	"./locales/zht/vendor.json": [
		32652,
		32652
	],
	"./pages/order/gift-card/success/order_confirm.json": [
		98445,
		98445
	],
	"./pages/support/preheat/preheat_cms_config.json": [
		38977,
		38977
	],
	"./pages/support/preheat/preheat_collect.json": [
		41878,
		41878
	],
	"./pages/support/preheat/preheat_order.json": [
		57944,
		57944
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 97787;
module.exports = webpackAsyncContext;